import type { ReactNode } from "react";

interface AdminShellProps {
	sidebar: ReactNode;
	topbar: ReactNode;
	children: ReactNode;
}

export function AdminShell({ sidebar, topbar, children }: AdminShellProps) {
	return (
		<div
			className="h-screen overflow-hidden bg-background"
			style={{
				display: "grid",
				gridTemplateColumns: "248px 1fr",
				gridTemplateRows: "60px 1fr",
				gridTemplateAreas: '"sidebar topbar" "sidebar main"',
			}}
		>
			<aside
				className="overflow-hidden flex flex-col border-r border-sidebar-border bg-sidebar"
				style={{ gridArea: "sidebar" }}
			>
				{sidebar}
			</aside>

			<header
				className="flex items-center border-b border-border bg-card z-20"
				style={{ gridArea: "topbar", position: "sticky", top: 0 }}
			>
				{topbar}
			</header>

			<main
				className="overflow-y-auto bg-background"
				style={{ gridArea: "main" }}
			>
				{children}
			</main>
		</div>
	);
}
